import Application from "../../Application";
import CaseLawDocumentTypeListPresenter, {
  ICaseLawDocumentTypeListPresenter
} from "../presenter/CaseLawDocumentTypeListPresenter";
import GetAllCaseLawDocumentTypesInteractor from "./GetAllCaseLawDocumentTypesInteractor";

export default class ShowCaseLawDocumentTypesInteractor {
  private application: Application;
  private output?: ICaseLawDocumentTypeListPresenter;
  private getAllCaseLawDocumentTypesInteractor: GetAllCaseLawDocumentTypesInteractor;

  constructor({ application, getAllCaseLawDocumentTypes }: any) {
    this.application = application;
    this.getAllCaseLawDocumentTypesInteractor = getAllCaseLawDocumentTypes;
  }

  execute() {
    this.output = CaseLawDocumentTypeListPresenter({
      application: this.application,
      initialState: {
        caseLawDocumentTypes: []
      }
    });
    this.getAllCaseLawDocumentTypesInteractor
      .execute()
      .then(this.output.loadAllCaseLawDocumentTypes);
    return this.output;
  }
}
